export class PathConstants {

    public static PATH_EMPTY: string = "";

    public static PATH_SECURITY: string = "security";
    public static PATH_LOGIN: string = "login";
    public static PATH_SECURITY_LOGIN: string = PathConstants.PATH_SECURITY + "/" + PathConstants.PATH_LOGIN;


    public static PATH_HOME: string = "web";
    public static PATH_INICIO: string = "inicio";

    public static PATH_VISION: string = "vision";
    public static PATH_MISION: string = "mision";
    public static PATH_DISTRIBUCION: string = "distribucion";
    public static PATH_HISTORIA: string = "historia";
    public static PATH_UBICACION: string = "ubicacion";
    public static PATH_PLAN: string = "plan";
    public static PATH_SERVICIO: string = "servicio";
    public static PATH_HABITACION: string = "habitacion";
    public static PATH_PLAN_PAG: string = "detalleplan"

    public static PATH_CONTACTO: string = "contacto";
    public static PATH_RESERVA: string = "reserva";


    public static FULLPATH_PAGINA_INICIO: string = PathConstants.PATH_HOME +"/"+PathConstants.PATH_INICIO;



    public static PATH_ADMIN: string = "administration";


    public static PATH_BANNERES: string = "banneres";
    public static PATH_BANNERES_SEARCH: string = "banneres-search";
    public static PATH_BANNERES_FORM: string = "banneres-form";
    public static FULLPATH_BANNERES_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_BANNERES + "/" + PathConstants.PATH_BANNERES_SEARCH;
    public static FULLPATH_BANNERES_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_BANNERES + "/" + PathConstants.PATH_BANNERES_FORM;
    
    public static PATH_FOTOS: string = "fotos";
    public static PATH_FOTOS_SEARCH: string = "fotos-search";
    public static PATH_FOTOS_FORM: string = "fotos-form";
    public static FULLPATH_FOTOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_FOTOS + "/" + PathConstants.PATH_FOTOS_SEARCH;
    public static FULLPATH_FOTOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_FOTOS + "/" + PathConstants.PATH_FOTOS_FORM;
    
    public static PATH_GALERIAS: string = "galerias";
    public static PATH_GALERIAS_SEARCH: string = "galerias-search";
    public static PATH_GALERIAS_FORM: string = "galerias-form";
    public static FULLPATH_GALERIAS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_GALERIAS + "/" + PathConstants.PATH_GALERIAS_SEARCH;
    public static FULLPATH_GALERIAS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_GALERIAS + "/" + PathConstants.PATH_GALERIAS_FORM;
    
    public static PATH_HABITACIONES: string = "habitaciones";
    public static PATH_HABITACIONES_SEARCH: string = "habitaciones-search";
    public static PATH_HABITACIONES_FORM: string = "habitaciones-form";
    public static FULLPATH_HABITACIONES_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_HABITACIONES + "/" + PathConstants.PATH_HABITACIONES_SEARCH;
    public static FULLPATH_HABITACIONES_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_HABITACIONES + "/" + PathConstants.PATH_HABITACIONES_FORM;
    
    public static PATH_PLANES: string = "planes";
    public static PATH_PLANES_SEARCH: string = "planes-search";
    public static PATH_PLANES_FORM: string = "planes-form";
    public static FULLPATH_PLANES_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_PLANES + "/" + PathConstants.PATH_PLANES_SEARCH;
    public static FULLPATH_PLANES_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_PLANES + "/" + PathConstants.PATH_PLANES_FORM;
    
    public static PATH_PRECIOS: string = "precios";
    public static PATH_PRECIOS_SEARCH: string = "precios-search";
    public static PATH_PRECIOS_FORM: string = "precios-form";
    public static FULLPATH_PRECIOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_PRECIOS + "/" + PathConstants.PATH_PRECIOS_SEARCH;
    public static FULLPATH_PRECIOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_PRECIOS + "/" + PathConstants.PATH_PRECIOS_FORM;
    
    public static PATH_RESERVAS: string = "reservas";
    public static PATH_RESERVAS_SEARCH: string = "reservas-search";
    public static PATH_RESERVAS_FORM: string = "reservas-form";
    public static FULLPATH_RESERVAS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_RESERVAS + "/" + PathConstants.PATH_RESERVAS_SEARCH;
    public static FULLPATH_RESERVAS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_RESERVAS + "/" + PathConstants.PATH_RESERVAS_FORM;
    
    public static PATH_TIPOLOGIAS: string = "tipologias";
    public static PATH_TIPOLOGIAS_SEARCH: string = "tipologias-search";
    public static PATH_TIPOLOGIAS_FORM: string = "tipologias-form";
    public static FULLPATH_TIPOLOGIAS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_TIPOLOGIAS + "/" + PathConstants.PATH_TIPOLOGIAS_SEARCH;
    public static FULLPATH_TIPOLOGIAS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_TIPOLOGIAS + "/" + PathConstants.PATH_TIPOLOGIAS_FORM;
    
    public static PATH_VALORES: string = "valores";
    public static PATH_VALORES_SEARCH: string = "valores-search";
    public static PATH_VALORES_FORM: string = "valores-form";
    public static FULLPATH_VALORES_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_VALORES + "/" + PathConstants.PATH_VALORES_SEARCH;
    public static FULLPATH_VALORES_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_VALORES + "/" + PathConstants.PATH_VALORES_FORM;
    
    public static PATH_VIDEOS: string = "videos";
    public static PATH_VIDEOS_SEARCH: string = "videos-search";
    public static PATH_VIDEOS_FORM: string = "videos-form";
    public static FULLPATH_VIDEOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_VIDEOS + "/" + PathConstants.PATH_VIDEOS_SEARCH;
    public static FULLPATH_VIDEOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_VIDEOS + "/" + PathConstants.PATH_VIDEOS_FORM;
    
    
}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/util/path.constants.ts